import {getLabelEstado} from "./estados";

const apresentacao = (label, color, icon, descricao) => ({
    label,
    color,
    icon,
    descricao
});

const ESTADOS = {
    AGUARDANDO_APROVACAO: apresentacao(
        "Aguardando aprovação",
        "info",
        "fact_check"
    ),
    EM_FILA: apresentacao("Em fila", "primary", "schedule"),
    PROCESSAMENTO: apresentacao("Em andamento", "warning", "sync"),
    PROCESSADO_COM_SUCESSO: apresentacao(
        "Etapa concluída",
        "success",
        "check_circle_outline"
    ),
    PROCESSADO_COM_ERRO: apresentacao("Com erro", "error", "error_outline"),
    RESULTADO_INDETERMINADO: apresentacao(
        "Resultado indeterminado",
        "warning",
        "report_problem"
    )
};

export function temAceiteOficialFornecedor(ocorrencia = {}) {
    const situacao = ocorrencia.situacaoFornecedor;
    const resposta = ocorrencia.resposta || {};
    return situacao
        ? situacao.aceiteTceMsConfirmado === true
        : resposta.aceiteTceMs === "CONFIRMADO" &&
              Boolean(ocorrencia.codigoRegistroInformacao) &&
              ocorrencia.codigoRegistroInformacao ===
                  resposta.codigoRegistroInformacao;
}

/** Apresentação comum a todos os eventos. Nunca altera estado, autorização ou elegibilidade. */
export function getSituacaoOcorrencia(ocorrencia = {}) {
    const base =
        ESTADOS[ocorrencia.estadoEnvio] ||
        apresentacao(
            getLabelEstado(ocorrencia.estadoEnvio) || "Situação não informada",
            "info",
            "help_outline"
        );
    if (
        (ocorrencia.destinoEntrega || ocorrencia.resposta?.destino) !==
        "FORNECEDOR"
    )
        return base;

    const situacao = ocorrencia.situacaoFornecedor;
    const resposta = ocorrencia.resposta || {};
    const estado = situacao?.estadoEntrega || resposta.estadoEntregaFornecedor;
    // A projeção nova confere a evidência persistida; o fallback mantém compatibilidade com APIs anteriores.
    const aceite = temAceiteOficialFornecedor(ocorrencia);
    if (estado === "ACEITA_PELO_FORNECEDOR" && aceite) {
        return apresentacao(
            "Aceito pelo TCE-MS",
            "success",
            "verified",
            "Aceite oficial registrado para este pacote."
        );
    }
    if (estado === "ACEITA_PELO_FORNECEDOR") {
        return apresentacao(
            "Recebido pelo fornecedor",
            "info",
            "inventory_2",
            "Aguardando aceite oficial do TCE-MS. O recebimento confirma apenas a custódia do pacote."
        );
    }
    if (estado === "REJEITADA_PELO_FORNECEDOR")
        return apresentacao(
            "Rejeitado pelo fornecedor",
            "error",
            "error_outline"
        );
    if (estado === "FALHA_ANTES_DO_ENVIO")
        return apresentacao(
            "Não entregue ao fornecedor",
            "error",
            "error_outline"
        );
    if (estado === "RESULTADO_INDETERMINADO")
        return apresentacao(
            "Resultado do fornecedor indeterminado",
            "warning",
            "report_problem",
            "Confira o resultado antes de qualquer nova tentativa."
        );
    if (situacao?.estadoReserva === "EXPIRADA") {
        return apresentacao(
            "Reserva expirada",
            "warning",
            "timer_off",
            "Prazo da reserva encerrado, sem recebimento confirmado. Aguarda tratamento pelo conector."
        );
    }
    if (situacao?.estadoReserva === "RESERVADA") {
        return apresentacao(
            "Reservado pelo fornecedor",
            "info",
            "bookmark_border",
            situacao.dependenciasPendentes
                ? "Reserva sem recebimento confirmado; há antecedentes pendentes de aceite oficial, revalidados antes do download."
                : "Reserva registrada, ainda sem confirmação de recebimento. Não representa aceite do TCE-MS."
        );
    }
    if (situacao?.dependenciasPendentes) {
        return apresentacao(
            "Aguardando aceite dos antecedentes",
            "warning",
            "account_tree",
            "Há antecedentes sem aceite oficial válido para este pacote. Eles precisam ser conferidos antes do consumo."
        );
    }
    if (estado === "PENDENTE")
        return apresentacao(
            "Aguardando consumo pelo fornecedor",
            "info",
            "outbox",
            "Nenhum recebimento confirmado. A disponibilidade será revalidada no momento da reserva."
        );
    if (estado === "PROCESSAMENTO")
        return apresentacao(
            "Entrega em andamento",
            "info",
            "sync",
            "Ainda não há confirmação de recebimento. Este estado, sozinho, não comprova reserva pela API."
        );
    if (
        [
            "AGUARDANDO_APROVACAO",
            "EM_FILA",
            "PROCESSADO_COM_ERRO",
            "RESULTADO_INDETERMINADO"
        ].includes(ocorrencia.estadoEnvio)
    )
        return base;
    return apresentacao(
        "Situação do fornecedor a conferir",
        "warning",
        "help_outline",
        "Sem informação suficiente para distinguir reserva, recebimento e aceite oficial. Consulte o detalhe da ocorrência."
    );
}
